export function sanitizeText(input: string, maxLength = 500): string {
  return input
    .replace(/[<>]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, maxLength);
}

export function sanitizeEmail(input: string): string {
  return input.trim().toLowerCase();
}
